import PatientStatusBadge from '@app/icare/components/status/PatientStatusBadge'
import PatientTitle from '@app/icare/entities/patient/components/PatientTitle'
import { patientQueryOptions } from '@app/icare/entities/patient/queries/patientQueryOptions'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Flex } from 'antd'

export const Route = createFileRoute('/_app/patienten/$id/_edit')({
  component: RouteComponent,
  loader: async ({ params, context: { queryClient } }) => {
    const data = await queryClient.ensureQueryData(patientQueryOptions(params.id))

    return {
      breadcrumb: [
        {
          label: (
            <Flex gap="small">
              <PatientTitle value={data} />
              <PatientStatusBadge value={data?.status} />
            </Flex>
          ),
          to: `/patienten/${params.id}`,
        },
      ],
    }
  },
})

function RouteComponent() {
  return <Outlet />
}
